import {FaReact, FaCss3Alt, FaLaravel, FaNode, FaBootstrap, FaGithub, FaHtml5} from 'react-icons/fa';
import {SiDjango, SiJavascript, SiVuedotjs, SiMysql, SiTailwindcss} from 'react-icons/si';
import { BiLogoPostgresql } from "react-icons/bi";
import { FaGitAlt } from "react-icons/fa6";
import { GrDocker } from "react-icons/gr";
import { GiTeamIdea } from "react-icons/gi";

import ProyectoInasistencias_1 from '../assets/Proyecto_Inasistencia1.png';
import ProyectoInasistencias_2 from '../assets/Proyecto_Inasistencia2.png';
import ProyectoInasistencias_3 from '../assets/Proyecto_Inasistencia3.png';
import ProyectoInasistencias_4 from '../assets/Proyecto_Inasistencia4.png';
import ProyectoInasistencias_5 from '../assets/Proyecto_Inasistencia5.png';
import ProyectoInasistencias_6 from '../assets/Proyecto_Inasistencia6.png';
import ProyectoInasistencias_7 from '../assets/Proyecto_Inasistencia7.png';
import ProyectoLab1 from '../assets/Proyecto_Lab1.png';
import ProyectoLab2 from '../assets/Proyecto_Lab2.png';
import ProyectoLab3 from '../assets/Proyecto_Lab3.png';
import ProyectoLab4 from '../assets/Proyecto_Lab4.png';
import Proyecto_Artesol from '../assets/Proyecto_Artesol.png';
import Proyecto_Artesol2 from '../assets/Proyecto_Artesol2.png';


import { FaHandshakeAngle } from "react-icons/fa6";
import { GiSandsOfTime } from "react-icons/gi";


export const BackendSkills =  [

    {
        id: 0 ,
        tech:'Django',
        icon: <SiDjango/>,
        color: 'rgb(9, 83, 55)',
      
    },
    {
        id: 1 ,
        tech:'Laravel',
        icon: <FaLaravel/>,
        color:' #FF2D20',
     
    },
    {
        id: 2 ,
        tech:'NodeJS',
        icon: <FaNode/>,
        color:' #339933',
       

    },
    {
        id: 3 ,
        tech:'MySQL',
        icon: <SiMysql/>,
        color:'  #00758F',
    

    },
    {
        id: 4 ,
        tech:'PostgreSQL',
        icon: <BiLogoPostgresql/>,
        color:' #848484',

    },

]

export const FrontendSkills =  [
    {
        id: 0 ,
        tech:'HTML5',
        icon: <FaHtml5/>,
        color: 'rgb(247, 114, 26)'
    },
    {
        id: 1 ,
        tech:'CSS',
        icon: <FaCss3Alt/>,
        color: 'rgb(68, 71, 250)'
    },
    {
        id: 2 ,
        tech:'Javascript',
        icon: <SiJavascript/>,
        color: 'rgb(255, 252, 48)'
    },
    {
        id: 0 ,
        tech:'React JS',
        icon: <FaReact/>,
        color: ' #61DAFB'
    },
    {
        id: 1 ,
        tech:'Vue',
        icon: <SiVuedotjs/>,
        color: ' #42B883'
    },

]

export const ToolsSkills =  [
    {
        id: 0 ,
        tech:'Github',
        icon: <FaGithub/>,
        color: 'rgb(255, 255, 255)'
    },
    {
        id: 1 ,
        tech:'Git',
        icon: <FaGitAlt/>,
        color: 'rgb(245, 89, 27)'
    },
    {
        id: 2 ,
        tech:'Docker',
        icon: <GrDocker/>,
        color: 'rgb(33, 183, 252)'
    },
    

]
export const SoftSkills =  [
    {
        id: 0 ,
        tech:'Trabajo en Equipo',
        icon: <GiTeamIdea/>,
        color: 'rgb(240, 227, 183)'
    },
    {
        id: 1 ,
        tech:'Compromiso',
        icon: <FaHandshakeAngle/>,
        color: 'rgb(245, 154, 138)'
    },
    {
        id: 2 ,
        tech:'Gestion del Tiempo',
        icon: <GiSandsOfTime/>,
        color: 'rgb(168, 93, 158)'
    },
    

]
export const projectDetails = [
    {
        id: 0,
        project_name:"Sistema Justificación de Inasistencias",
        project_desc:"Sistema que permite realizar justificación de inasistencias por parte de alumnos.",
        tech_stack: ["React JS","Django","Docker","MySQL"],
        tech_color: ["#61DAFB","rgb(9, 83, 55)","rgb(33, 183, 252)","#00758F"],
        project_imgs: [ProyectoInasistencias_1,ProyectoInasistencias_2,
            ProyectoInasistencias_4,ProyectoInasistencias_5,ProyectoInasistencias_6,ProyectoInasistencias_7],
        project_url: "https://github.com/FabianSanabria/Proyecto_Justificacion_Inasistencias",
        reverse:false,
    },
     {
        id: 2,
        project_name:"Laboratorio de Servicios Analíticos UCN",
        project_desc:"Página web dedicada al control y gestión de muestras de laboratorio, y su proceso en el cual son analizadas.",
        tech_stack: ["Laravel","Vue"],
        tech_color: ["#FF2D20","#42B883"],
        project_imgs: [ProyectoLab3,ProyectoLab1,ProyectoLab2,,ProyectoLab4],
        project_url: "https://lsa.laboratorioquimico.cl",
        reverse:true,
    },
    {
        id: 1,
        project_name:"Artésol: Infusiones que Sanan",
        project_desc:"Página web de Ecommerce relacionada a la venta de tés.",
        tech_stack: ["Wordpress"],
        tech_color: ["#00758F"],
        project_imgs: [Proyecto_Artesol,Proyecto_Artesol2],
        project_url: "https://www.artesol.cl",
        reverse:false,
    }
   
   
    
]   
export const navLinks = [
    {
        id: 0,
        name: 'Inicio',
        href: 'home',

    },
    {
        id: 1,
        name: 'Sobre mí',
        href: 'about-me',

    },
    {
        id: 2,
        name: 'Mis Skills',
        href: 'skills',
        
    },
    {
        id: 3,
        name: 'Proyectos',
        href: 'projects',
        
    },

]   